import React, { useState } from 'react';
import { toast } from 'react-toastify';
import API from '../../api/client';

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      // Adjust your Axios instance name/path as needed:
      await API.post<{ message: string }>('/api/newsletter-signup/', {
        email,
      }).then((response) => {
        toast.success(response.data.message);
      });
      setEmail('');
    } catch (error) {
      toast.error('Error: ' + error);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="relative 
            border-2 
            border-sea 
            rounded-full  
            bg-white
            px-2 
            py-2 
            focus:ring 
            focus:ring-sea
            w-5/6"
    >
      <input
        type="email"
        name="email"
        placeholder="E-MAIL"
        className="
            w-5/6
            bg-white 
            px-6 
            py-4 
            rounded-full  
            text-xs
            md:text-base
            bg-white
            placeholder:text-maroon/60 
            text-maroon 
            font-prosto 
            focus:outline-none 
            z-0
          "
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <button
        type="submit"
        className="
            absolute
            z-1
            bg-sea
            text-white
            font-prosto
            rounded-full
            px-4
            py-4
            top-1
            right-2
            border-2 
          "
      >
        OK
      </button>
    </form>
  );
};

export default NewsletterSignup;
